export const iconFontAwesomeFilmVideoFilm = (
	<i className="fa-solid fa-film"></i>
);
